export const WEB_API = "https://scgp-riskeval-api.azurewebsites.net/admin-api/";
// export const WEB_API = 'http://localhost:4011/admin-api/';
export const AZURE_STORAGE_CONNECTION_STRING =
  'https://riskevaluationstoragedev.blob.core.windows.net/;QueueEndpoint=https://riskevaluationstoragedev.queue.core.windows.net/;FileEndpoint=https://riskevaluationstoragedev.file.core.windows.net/;TableEndpoint=https://riskevaluationstoragedev.table.core.windows.net/;SharedAccessSignature=sv=2020-02-10&ss=b&srt=co&sp=rwdlactfx&se=2021-06-30T14:26:01Z&st=2021-05-27T06:26:01Z&spr=https&sig=6Ela0GICiIuAL9eCNUHqeZJgQWhQaLzui%2B2PXargmaw%3D';
// export const WEBSITE_URL = "http://122.155.0.74:4010";

// // dev
export const VERSION_RELEASE = '0.0.1.15';
